<template>
  <DefaultSection class="is-medium has-border-section">
    <Container>
      <h2
        v-if="title"
        class="is-title is-size-medium has-text-weight-bold has-text-centered mb-6"
      >
        {{ title }}
      </h2>
      <ParagraphSmirchImageSliderCarousel :slides="slides" />

      <div
        v-if="states"
        class="state-list has-text-white has-background-bright-gray-blue"
      >
        <div class="status-icons has-text-centered">
          <img
            alt="Status"
            src="~/assets/svgs/statuses.svg?url"
            data-not-lazy
          />
        </div>
        <div class="columns">
          <div class="column is-offset-1-widescreen">
            <div class="wrapper">
              <span class="state-wrapper">
                <Status status="new" class="state" />
              </span>
              <span
                v-if="states[0]"
                class="has-text-weight-semibold is-size-normal text-shadow wrapper"
              >
                {{ states[0] }}
              </span>
            </div>

            <div class="wrapper">
              <span class="state-wrapper">
                <Status status="assigned" class="state" />
              </span>
              <span
                v-if="states[1]"
                class="has-text-weight-semibold is-size-normal text-shadow wrapper"
              >
                {{ states[1] }}
              </span>
            </div>
            <div class="wrapper">
              <span class="state-wrapper">
                <Status status="done" class="state" />
              </span>
              <span
                v-if="states[2]"
                class="has-text-weight-semibold is-size-normal text-shadow wrapper"
              >
                {{ states[2] }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphSmirchImageSliderFragment } from '#graphql-operations'

defineProps<ParagraphSmirchImageSliderFragment>()

defineBlokkli({
  bundle: 'smirch_image_slider',
  propsFieldMapping: {
    title: null,
    slides: { type: 'field', name: 'field_smirch_slides_ref' },
    states: null,
  },
})
</script>

<style scoped lang="scss">
.state-list {
  box-shadow: 0 12px 32px -8px rgba(26, 26, 26, 0.6);

  padding-top: toRem(60);
  padding-bottom: toRem(60);
  margin-top: toRem(80);
  margin-bottom: toRem(0);

  padding-right: toRem(60);
  padding-left: toRem(60);

  border-radius: 10px;

  @include desktop {
    margin-left: 95px;
    margin-right: 95px;
  }

  @include mobile {
    padding-top: toRem(30);
    padding-bottom: toRem(40);
    padding-right: toRem(30);
    padding-left: toRem(30);
  }

  .status-icons {
    margin-top: toRem(-40);
    margin-bottom: toRem(40);

    @include tablet {
      margin-top: toRem(-70);
      margin-bottom: toRem(60);
    }
  }

  .state-wrapper {
    display: block;
    text-align: center;
    margin-bottom: 1rem;
    @include tablet {
      display: inline-block;
      width: 130px;
      text-align: left;
      margin-bottom: 0;
    }
  }

  .wrapper {
    text-align: center;
    margin-bottom: 1rem;
    min-height: 3rem;
    @include tablet {
      text-align: left;
    }
  }
}
</style>
